import { api, ApiError } from '@/lib/api';

import { lerManutencao, type Manutencao } from '@alianca/core/contracts/configuracoes';

let cached: Promise<Manutencao> | null = null;

/** Lê o status da manutenção. 503 `maintenance` é a manutenção de deploy (`MAINTENANCE=1`): ativa, sem previsão. */
export function buscarManutencao(): Promise<Manutencao> {
    return api(lerManutencao, {})
        .then((m) => ({ ativa: m.ativa, previsao_fim: m.previsao_fim ? new Date(m.previsao_fim) : null }))
        .catch((e: unknown) => {
            if (e instanceof ApiError && e.code === 'maintenance') return { ativa: true, previsao_fim: null };
            throw e;
        });
}

/** Memoizado por carga de página (o guard do router); a manutenção ligada depois chega pelo 503 do `api()`. */
export function getManutencao(): Promise<Manutencao> {
    cached ??= buscarManutencao().catch((e: unknown) => {
        cached = null;
        throw e;
    });
    return cached;
}
